import React from 'react'
import {MetalColor, Finish, Gemstones, NextSteps, RingFaceShape, RaisedOrRecessed, RingFaceSize, ShoulderDesigns} from './shared'

const METAL_COLOR_CARDS = [
  {
    name: "silver_color",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/metal/silver.jpg`,
    label: "White Gold, Silver, Platinum"
  },
  {
    name: "yellow",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/metal/yellow-gold.jpg`,
    label: "Yellow Gold"
  },
  {
    name: "rose",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/metal/rose-gold.jpg`,
    label: "Rose Gold"
  },
  {
    name: "mixed_metals",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/metal/mixed.jpg`,
    label: "Mixed Metals"
  }
]

export const SignetMetalColor = () => <MetalColor cards={METAL_COLOR_CARDS} />

const FINISH_CARDS = [
  {
    name: "polished",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/finish/polished.jpg`,
    label: "Polished"
  },
  {
    name: "brushed",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/finish/brushed.jpg`,
    label: "Brushed"
  },
  {
    name: "oxidized",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/finish/oxidized.jpg`,
    label: "Oxidized"
  },
  {
    name: "enamel",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/finish/enamel.jpg`,
    label: "Enamel"
  }
]

export const SignetFinish = () => <Finish cards={FINISH_CARDS} />


const GEMSTONES_CARDS = [
  {
    name: "no_stone",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/gem/none.jpg`,
    label: "No Stone"
  },
  {
    name: "center_stone",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/gem/center.jpg`,
    label: "Center Stone"
  },
  {
    name: "accent_stones",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/gem/accent.jpg`,
    label: "Accent Stones"
  }
]

export const SignetGemstones = () => <Gemstones cards={GEMSTONES_CARDS} />

const RING_FACE_SHAPE_CARDS = [
  {
    name: "circle",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/circle.jpg`,
    label: "Circle"
  },
  {
    name: "portrait_oval",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/portrait-oval.jpg`,
    label: "Portrait Oval"
  },
  {
    name: "landscape_oval",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/landscape-oval.jpg`,
    label: "Landscape Oval"
  },
  {
    name: "square",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/square.jpg`,
    label: "Square"
  },
  {
    name: "portrait_rectangle",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/portrait-rectangle.jpg`,
    label: "Portrait Rectangle"
  },
  {
    name: "landscape_rectangle",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/landscape-rectangle.jpg`,
    label: "Landscape Rectangle",
  },
  {
    name: "shield",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/shield.jpg`,
    label: "Shield"
  },
  {
    name: "custom",
    img: `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/face/custom.jpg`,
    label: "Custom"
  },
]

export const SignetFaceShape = () => <RingFaceShape cards={RING_FACE_SHAPE_CARDS} />

const RAISED_OR_RECESSED_CARDS = [
  {
    name: "raised",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/raised-0.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/raised-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/raised-2.jpg`,
    ],
    label: "Raised"
  },
  {
    name: "recessed",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/recessed-0.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/recessed-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/recessed-2.jpg`,
    ],
    label: "Recessed"
  },
  {
    name: "recessed_and_mirrored",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/recessed-mirrored-0.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/recessed-mirrored-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/raise-or-recess/recessed-mirrored-2.jpg`,
    ],
    label: "Recessed and Mirrored"
  }
]

export const SignetRaisedOrRecessed = () => <RaisedOrRecessed cards={RAISED_OR_RECESSED_CARDS} />

export const SignetRingFaceSize = () => <RingFaceSize
  img="//images.custommade.com/6OFBczxkQeWLysUYI7FZYOK1x3k=/custommade-attachments/9b15153024f196c_7_ring_face_size_2_screen_7_2_2.png"
  />

export const SHOULDER_DESIGNS = [
  {
    name: "same_on_both_sides",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/same-0.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/same-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/same-2.jpg`,
    ],
    label: "Same on both sides",
  },
  {
    name: "different",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/different-0.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/different-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/different-2.jpg`,
    ],
    label: "Different design on each side",
  },
  {
    name: "no_designs",
    imgs: [
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/none-0.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/none-1.jpg`,
      `${window.cm.structureUrl}/static/images/brand2025/project-creation/signet/shoulder/none-2.jpg`,
    ],
    label: "No shoulder design",
  }
]

export const SignetShoulderDesigns = () => <ShoulderDesigns cards={SHOULDER_DESIGNS} />

const NEXT_STEPS_CARDS = [
  {
    name: "price",
    description: "Our design experts will prepare some initial quotes for you to review as a starting point for your ring.",
    label: "I’d like to discuss price first."
  },
  {
    name: "questions",
    description: "If you have other things you’d like to discuss before our team gets started, let us know - one of our ring consultants will get in touch.",
    label: "I have questions to ask or other details to share first."
  },
  {
    name: "looking_around",
    description: "Just looking around for now? We’ll hold onto your details and you can let us know when you’re ready to get started.",
    label: "I’m not ready for a consultation yet."
  }
]

export const SignetNextSteps = () => <NextSteps cards={NEXT_STEPS_CARDS} />
